import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {UpdateNovaAgentInput, UpdateNovaAgentMutation} from './__generated__/UpdateNovaAgentMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

// Relay merges the returned `agent` node into the store by `id`, so no updater/configs are
// needed here. If `categoryId` changed, the agent moves to a different category's `agents`
// connection — since that connection is only paginated from the category side, the caller
// should refetch the catalogue in `onSuccess` when `categoryId` changed.
const mutation = graphql`
	mutation UpdateNovaAgentMutation($input: UpdateNovaAgentInput!) {
		updateNovaAgent(input: $input) {
			agent {
				id
				name
				title
				description
				shape
				categoryId
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<UpdateNovaAgentInput>,
	onSuccess?: RelayOnCompleted<UpdateNovaAgentMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation<UpdateNovaAgentMutation>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
